import type { CrehanaTFunction } from '@crehana/i18n';

import {
  OrganizationDepartmentEnum,
  OrganizationRoleEnum,
} from '@/shared/types/graphql/globals';

export const getTitle = (
  userInteraction: string | null | undefined,
  currentStep: number,
) => {
  const titles = [
    {
      title: 'FORM_STEPS_CONTEXT_1',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_2',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_3',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_4',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_5',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_6',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_7',
      subTitle: userInteraction,
    },
    {
      title: 'FORM_STEPS_CONTEXT_8',
      subTitle: userInteraction,
    },
  ];

  return titles[currentStep];
};

export const INPUT_MAX_LENGTH = 50;

export enum FormSteps {
  FORM_STEP_FULLNAME = 'Step Full Name',
  FORM_STEP_COUNTRY = 'Step Country',
  FORM_STEP_EMAIL = 'Step Email',
  FORM_STEP_COMPANY = 'Step Company',
  FORM_STEP_COMPANY_SIZE = 'Step Company Size',
  FORM_STEP_ROLE = 'Step Role',
  FORM_STEP_DEPARTMENT = 'Step Department',
  FORM_STEP_PHONE = 'Step Phone',
  FORM_STEP_LOAD = 'Step Load',
}

export const COUNTRIES = [
  { value: 'AR', label: 'TRIAL_FORM_COUNTRY_1' },
  { value: 'BZ', label: 'TRIAL_FORM_COUNTRY_2' },
  { value: 'BO', label: 'TRIAL_FORM_COUNTRY_3' },
  { value: 'BR', label: 'TRIAL_FORM_COUNTRY_4' },
  { value: 'CL', label: 'TRIAL_FORM_COUNTRY_5' },
  { value: 'CO', label: 'TRIAL_FORM_COUNTRY_6' },
  { value: 'CR', label: 'TRIAL_FORM_COUNTRY_7' },
  { value: 'CB', label: 'TRIAL_FORM_COUNTRY_8' },
  { value: 'EC', label: 'TRIAL_FORM_COUNTRY_9' },
  { value: 'SV', label: 'TRIAL_FORM_COUNTRY_10' },
  { value: 'ES', label: 'TRIAL_FORM_COUNTRY_12' },
  { value: 'US', label: 'TRIAL_FORM_COUNTRY_13' },
  { value: 'GT', label: 'TRIAL_FORM_COUNTRY_14' },
  { value: 'HN', label: 'TRIAL_FORM_COUNTRY_15' },
  { value: 'MX', label: 'TRIAL_FORM_COUNTRY_16' },
  { value: 'NI', label: 'TRIAL_FORM_COUNTRY_17' },
  { value: 'PA', label: 'TRIAL_FORM_COUNTRY_18' },
  { value: 'PY', label: 'TRIAL_FORM_COUNTRY_19' },
  { value: 'PE', label: 'TRIAL_FORM_COUNTRY_20' },
  { value: 'PR', label: 'TRIAL_FORM_COUNTRY_21' },
  { value: 'DO', label: 'TRIAL_FORM_COUNTRY_22' },
  { value: 'UY', label: 'TRIAL_FORM_COUNTRY_23' },
  { value: 'VE', label: 'TRIAL_FORM_COUNTRY_24' },
  { value: '*', label: 'TRIAL_FORM_COUNTRY_25' },
];

export const getDepartmentOptions = (t: CrehanaTFunction<string>) => [
  {
    label: t('USER_DEPARTMENT_HR'),
    value: OrganizationDepartmentEnum.HUMAN_RESOURCES,
  },
  {
    label: t('USER_DEPARTMENT_INNOVATION_IT'),
    value: OrganizationDepartmentEnum.INNOVATION,
  },
  {
    label: t('USER_DEPARTMENT_MARKETING'),
    value: OrganizationDepartmentEnum.MARKETING,
  },
  {
    label: t('USER_DEPARTMENT_MANAGEMENT'),
    value: OrganizationDepartmentEnum.ADMIN,
  },
  {
    label: t('USER_DEPARTMENT_SALES'),
    value: OrganizationDepartmentEnum.SALES,
  },
  {
    label: t('USER_DEPARTMENT_TI'),
    value: OrganizationDepartmentEnum.IT,
  },
  {
    label: t('USER_DEPARTMENT_OPERATIONS'),
    value: OrganizationDepartmentEnum.OPERATIONS,
  },
  {
    label: t('USER_DEPARTMENT_FINANCES'),
    value: OrganizationDepartmentEnum.FINANCE,
  },
  {
    label: t('USER_DEPARTMENT_OTHER'),
    value: OrganizationDepartmentEnum.OTHER,
  },
];

export const getRoleOptions = (t: CrehanaTFunction<string>) => [
  {
    label: t('USER_ROLE_CEO'),
    value: OrganizationRoleEnum.CEO,
  },
  {
    label: t('USER_ROLE_C_LEVEL'),
    value: OrganizationRoleEnum.C_LEVEL,
  },
  {
    label: t('USER_ROLE_VP'),
    value: OrganizationRoleEnum.VP,
  },
  {
    label: t('USER_ROLE_MANAGER'),
    value: OrganizationRoleEnum.MANAGEMENT,
  },
  {
    label: t('USER_ROLE_FOUNDER'),
    value: OrganizationRoleEnum.FOUNDER,
  },
  {
    label: t('USER_ROLE_DIRECTOR'),
    value: OrganizationRoleEnum.DIRECTOR,
  },
  {
    label: t('USER_ROLE_COORDINATOR'),
    value: OrganizationRoleEnum.GENERALIST_COORDINATOR,
  },
  {
    label: t('USER_ROLE_EXECUTIVE'),
    value: OrganizationRoleEnum.EXECUTIVE,
  },
  {
    label: t('USER_ROLE_ANALIST'),
    value: OrganizationRoleEnum.ANALYST,
  },
  {
    label: t('USER_ROLE_INTERN'),
    value: OrganizationRoleEnum.INTERN,
  },
  {
    label: t('USER_ROLE_FREELANCE'),
    value: OrganizationRoleEnum.FREELANCE,
  },
  {
    label: t('USER_ROLE_STUDENT'),
    value: OrganizationRoleEnum.ESTUDIANTE,
  },
  {
    label: t('USER_ROLE_OTHER'),
    value: OrganizationRoleEnum.OTHER,
  },
];
